import React, { useEffect, useState } from 'react';
import RequiredInput from './InputHOC';

interface Props {
    id: string;
    label: string;
    placeholder?: string;
    isRequired?: boolean;
    isClearable?: boolean;
    filters: any;
    updateFilters: (filter: any) => void;
    delay?: number;
    [key: string]: any;
}

const CustomTextDelayInput: React.FC<Props> = ({
    id,
    label,
    filters,
    placeholder,
    updateFilters,
    delay = 1000, // Retraso por defecto de 1000 ms
    isRequired = false,
    isClearable = false,
    ...props
}) => {
    const [inputValue, setInputValue] = useState<string>(filters.filter_filters?.[id] || '');
    const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.replace('%', '');
        setInputValue(value);

        if (timer) {
            clearTimeout(timer);
        }

        const newTimer = setTimeout(() => {
            updateFilters({ [id]: value });
        }, delay);

        setTimer(newTimer);
    };

    useEffect(() => {
        setInputValue(filters.filter_filters?.[id] || '');
    }, [filters]);

    return (
        <RequiredInput
            required={isRequired}
            clearable={isClearable}
            id={id}
            label={label}
            value={inputValue}
            onChange={handleChange}
            placeholder={placeholder}
            {...props}
        />
    );
};

export default CustomTextDelayInput;
